// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.dialog-message[data-v-41951e14] {\n  width: 370px;\n}\n", ""]);
// Exports
module.exports = exports;
